import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientContactCompleteView のスタイル
 */
export const hotlineClientContactCompleteViewStyle = tv({
    slots: {
        contentWrap: ['w-full'],
    },
    variants: {},
});
